module.exports = __webpack_public_path__ + "static/media/medal_level3.da70af4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/levels/medal_level3.png
// module id = 300
// module chunks = 0